// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__39RtJ","bigColWidth":"Table_bigColWidth__1Rlwk","biggerColWidth":"Table_biggerColWidth__2GWzq","row":"Table_row__2P_MQ","col":"Table_col__vw8-U"};